// Select nativo estilizado — sem libs externas. Acessível por default (semantics
// nativos de <select>), keyboard ready, OS picker em mobile.
import { forwardRef, type SelectHTMLAttributes } from 'react';
import styles from './Select.module.css';
import { cn } from '@/lib/utils/cn';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export type SelectSize = 'sm' | 'md';

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  options: SelectOption[];
  size?: SelectSize;
  /** Render adornment à esquerda do select (ícone). */
  leadingIcon?: React.ReactNode;
}

const sizeClass: Record<SelectSize, string> = {
  sm: styles.sm,
  md: styles.md,
};

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { options, size = 'md', leadingIcon, className, ...rest },
  ref,
) {
  return (
    <span className={cn(styles.wrap, sizeClass[size], className)}>
      {leadingIcon && <span className={styles.leadingIcon}>{leadingIcon}</span>}
      <select ref={ref} className={styles.select} {...rest}>
        {options.map((o) => (
          <option key={o.value} value={o.value} disabled={o.disabled}>
            {o.label}
          </option>
        ))}
      </select>
      <span className={styles.chevron} aria-hidden="true">
        ▾
      </span>
    </span>
  );
});
